import React, { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { common } from "../js/common";

function RegisterPage() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [alert, setAlert] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleRegister = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");

      const response = await common.fetchRestAPI("accounts", "POST", {
        userName: username,
        email: email.trim(),
        password: password,
      });

      if (response.status === 409) {
        setIsLoading(false);
        setError("An account with that username or email already exists.");
        return;
      }

      if (!response.ok) {
        const data = await response.json().catch(() => null);
        setIsLoading(false);
        setError(data?.error || "Failed to create account.");
        return;
      }

      setIsLoading(false);
      setAlert("Account created! Redirecting to login...");
      await new Promise((resolve) => setTimeout(resolve, 2000));
      window.location.href = "/login";
    } catch {
      setIsLoading(false);
      setError("An error occurred creating your account.");
    }
  };

  return (
    <Container className="vh-100 mx-auto p-4" style={{ maxWidth: "576px" }}>
      <div
        className="d-flex flex-column justify-content-center"
        style={{ height: "100%" }}
      >
        <a href="/">&lt; Home</a>
        <h1 className="text-center p-3">Create Account</h1>
        <Form onSubmit={handleRegister}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              name="username"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              maxLength={55}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              maxLength={255}
              required
            />
            <div className="form-text">Used only to reset your password.</div>
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create Account"}
          </button>
          <p className="mt-3">
            Already have an account? <a href="/login">Log in</a>
          </p>
          <div className="p-2 d-flex justify-content-center align-items-center">
            {isLoading ? (
              <div className="m-3">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : alert !== "" ? (
              <div className="alert alert-success" role="alert">
                <strong>{alert}</strong>
              </div>
            ) : error !== "" ? (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError("")}
                  aria-label="Close"
                ></button>
              </div>
            ) : null}
          </div>
        </Form>
      </div>
    </Container>
  );
}

export default RegisterPage;
